/**
 * features/Modal/ui/TechCardDetailModal.jsx
 *
 * Просмотр тех. карты: компоненты (сырьё) + выходные изделия.
 */
import React from "react";
import {
  Modal, Descriptions, Tag, Table,
} from "antd";

const CARD_MODE_CONFIG = {
  reference: { color: "blue",   text: "Справочный"  },
  semi_auto: { color: "orange", text: "Полуавтомат" },
  auto:      { color: "green",  text: "Автомат"     },
};

export default function TechCardDetailModal({ record, onClose }) {
  if (!record) return null;

  const modeCfg = CARD_MODE_CONFIG[record.card_mode]
    || { color: "default", text: record.card_mode || "—" };

  
  const itemsColumns = [
    {
      title:     "Номенклатура ID",
      dataIndex: "nomenclature_id",
      key:       "nom_id",
      render:    (id) => id ? <Tag>#{id}</Tag> : "—",
    },
    { title: "Тип обработки",     dataIndex: "type_of_processing",       key: "proc" },
    { title: "Кол-во",            dataIndex: "quantity",                  key: "qty"  },
    { title: "Вес нетто",         dataIndex: "net_weight",                key: "net", render: (v) => v ?? "—" },
    { title: "Вес брутто",        dataIndex: "gross_weight",              key: "gross", render: (v) => v ?? "—" },
    { title: "Выход",             dataIndex: "output",                    key: "out", render: (v) => v ?? "—" },
    { title: "Потери (холод.)",   dataIndex: "waste_from_cold_processing", key: "cold", render: (v) => v ?? "—" },
    { title: "Потери (тепл.)",    dataIndex: "waste_from_heat_processing", key: "heat", render: (v) => v ?? "—" },
  ];

  
  const outputColumns = [
    {
      title:     "Номенклатура ID",
      dataIndex: "nomenclature_id",
      key:       "nom_id",
      render:    (id) => id ? <Tag color="green">#{id}</Tag> : "—",
    },
    { title: "Количество", dataIndex: "quantity", key: "qty" },
    {
      title:     "Ед. изм.",
      dataIndex: "unit_id",
      key:       "unit",
      render:    (id) => id ? `#${id}` : "—",
    },
  ];

  return (
    <Modal
      open={!!record}
      onCancel={onClose}
      footer={null}
      title={`Тех. карта: ${record.name}`}
      width={900}
    >
      <Descriptions column={2} size="small" bordered style={{ marginBottom: 16 }}>
        <Descriptions.Item label="Режим">
          <Tag color={modeCfg.color}>{modeCfg.text}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Статус">
          <Tag>{record.status}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Родная номенклатура">
          {record.parent_nomenclature_id ? `#${record.parent_nomenclature_id}` : "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Автопроизводство">
          {record.auto_produce ? "Да" : "Нет"}
        </Descriptions.Item>
        {record.card_mode !== "reference" && (
          <>
            <Descriptions.Item label="Склад сырья">
              {record.warehouse_from_id
                ? <Tag color="red">#{record.warehouse_from_id}</Tag>
                : "—"}
            </Descriptions.Item>
            <Descriptions.Item label="Склад продукта">
              {record.warehouse_to_id
                ? <Tag color="green">#{record.warehouse_to_id}</Tag>
                : "—"}
            </Descriptions.Item>
          </>
        )}
        {record.description && (
          <Descriptions.Item label="Описание" span={2}>
            {record.description}
          </Descriptions.Item>
        )}
      </Descriptions>

      <h1 className="text-lg font-bold py-2">Компоненты (сырьё)</h1>
      <Table
        rowKey={(r, i) => r.id || i}
        size="small"
        pagination={false}
        dataSource={record.items || []}
        columns={itemsColumns}
        locale={{ emptyText: "Нет компонентов" }}
        scroll={{ x: 700 }}
      />

      {(record.output_items && record.output_items.length > 0) && (
        <>
          <h1 className="text-lg font-bold py-2">Выходные изделия (производство)</h1>
          <Table
            rowKey={(r, i) => r.id || i}
            size="small"
            pagination={false}
            dataSource={record.output_items}
            columns={outputColumns}
            locale={{ emptyText: "Нет выходных изделий" }}
          />
        </>
      )}
    </Modal>
  );
}